module.exports = __webpack_public_path__ + "img/IconSkinConsultation.c4fe55d2.svg";